<template>
    <div>
        <label class="form-control-label">{{ element.text }}</label>
        <input type="text" class="form-control" :placeholder="element.placeholder">
    </div>
</template>

<script>
    export default {
        name: "TextInputElementPreview",
        props: {
            element: {
                type: Object
            }
        }
    }
</script>

<style scoped>

</style>